import { render } from "./Click610Icon.vue?vue&type=template&id=64167c8e"
import script from "./Click610Icon.vue?vue&type=script&lang=js"
export * from "./Click610Icon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__